import { Flex } from "antd";
import style from "./countBadge.module.css";
import { countBadgeColorMap } from "interfaces";

export const CountBadge = ({
  count,
  color = "basic",
}: {
  count: number | string;
  color?: keyof typeof countBadgeColorMap;
}) => {
  return (
    <Flex align="center" className={`${style.countBadge} ${style[countBadgeColorMap[color]]}`}>
      {count}
    </Flex>
  );
};
